"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetchError = void 0;
const createFetchError = (requestId, message = 'Unknown') => ({
    id: requestId,
    body: `{ "error": "${message}" }`,
    status: 0,
    statusText: 'ko',
    ok: false,
    headers: {
        'content-type': 'application/json',
    },
});
exports.createFetchError = createFetchError;
//# sourceMappingURL=utils.js.map